import qs from 'qs';
import axios from 'axios';
axios.defaults.withCredentials=true;
axios.defaults.headers = {
  'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
}
const baseURL = process.env.BASE_URL;
function _fetch(param) {
	if (param.data && param.data['X-PDD-VerifyAuthToken']) {
		axios.defaults.headers['X-PDD-VerifyAuthToken'] = param.data['X-PDD-VerifyAuthToken'];
		delete param.data['X-PDD-VerifyAuthToken'];
	}
	const pati = window.localStorage.getItem('X-PDD-Pati');
	const pageCode = window.localStorage.getItem('X-PDD-PageCode');
	axios.defaults.headers['X-PDD-Pati'] = pati;
	axios.defaults.headers['X-PDD-PageCode'] = pageCode;
	return axios({
    method: param.method || 'GET',
    data: qs.stringify(param.data),
    url: `${baseURL}${param.url}`,
  }).then(result => {
    const data = result.data;
    if (!data.isSuccess && data.errorCode === 'login_invalid') {
      window.location = data.data;
    } else {
      return result.data;
    }
  }).catch(error => {
    return handleError(error);
  });
}

function handleError(error) {
  console.error(error);
  if(error.code == 'ECONNABORTED' && error.message.indexOf('timeout')!=-1){
    return errorResponse('timeout', '请求超时');
  } else {
    return errorResponse(error.code, error.message);
  }
}

function errorResponse(errorCode, errorMsg) {
  return {
    errorCode,
    errorMsg,
    isSuccess: false,
  }
}

function post(url, data) {
  return _fetch({
    url,
    data,
    method: 'POST',
  });
}

function get(url, data) {
  return _fetch({
    url,
    data,
    method: 'GET',
  });
}

export {
  post,
  get,
};



// WEBPACK FOOTER //
// ./src/utils/http.js